import { parse } from 'tldts';

export default class UrlFormatter {

  static domain(url) {
    if (!url) return null;

    const result = parse(url);

    return result.domain || null;
  }
}